

export const order_post_recipient_rule=[
    {
        field_name: "name",
        field_rules: [
          {
            name: "required",
          },
        ],
      },
    {
      field_name: "line_1",
      field_rules: [
        {
          name: "required",
        },
      ],
    },
    {
      field_name: "city",
      field_rules: [
        {
          name: "required",
        },
      ],
    },
    {
      field_name: "state",
      field_rules: [
        {
          name: "required",
        },
      ],
    },
    {
      field_name: "zip",
      field_rules: [
        {
          name: "required",
        }, 
        {
          name:"zipCodeRule"
        }
      ],
    },
    {
      field_name: "country",
      field_rules: [
        {
          name: "required",
        },
      ],
    },
  ]

  export const order_email_recipient_rule=[
    {
      field_name: "name",
      field_rules: [
        {
          name: "required",
        },
      ],
    },
    {
      field_name: "email",
      field_rules: [
        {
          name: "required",
        },
      ],
    }
  ]


  export const validateFields = (param, validationRules = [], mode) => {

    console.log("validationRules",validationRules,param);
    
      var validationErrorMessages = []
      for (let validationRule of validationRules) {
        var fieldName = validationRule.field_name
        if (mode == "create" || (mode == "edit" && fieldName in param)) {
          if (validationRule.field_rules) {
            for (let fieldRule of validationRule.field_rules) {
              switch (fieldRule.name) {
                case "required":
                  if (!param[fieldName] ||param[fieldName]=="") {
                    var errorMessage = {
                      field_name: fieldName,
                      message: `${fieldName}_reqd`,
                    }
                    validationErrorMessages.push(errorMessage)
                  }
                  break
                case "validEmail":
                  var validRegex =
                    /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/
                  if (param.email) {
                    if (!param.email.match(validRegex)) {
                      validationErrorMessages.push({
                        field_name: "email",
                        message: "email_invalid",
                      })
                    }
                  }
                  break
                case "validPassword":
                  var password = param.password
                  if (password) {
                    if (password.length < 8) {
                      validationErrorMessages.push({
                        field_name: "password",
                        message: "password_min_8_chars",
                      })
                    }
                    if (!password.match(/[a-z]/)) {
                      validationErrorMessages.push({
                        field_name: "password",
                        message:
                          "password_min_1_lowercase",
                      })
                    }
                    if (!password.match(/[A-Z]/)) {
                      validationErrorMessages.push({
                        field_name: "password",
                        message:
                          "password_min_1_uppercase",
                      })
                    }
                    if (!password.match(/[@$!%*#?&\-_~,:;`^]/)) {
                      validationErrorMessages.push({
                        field_name: "password",
                        message:
                          "password_min_1_special",
                      })
                    }
                  }
                  break
                case "maxLength":
                  var field_value = param[fieldName]
                  var maxCharacters = fieldRule.characters || 0
                  if (field_value) {
                    if (field_value.length > maxCharacters) {
                      validationErrorMessages.push({
                        field_name: fieldName,
                        message: "exceeded_" + maxCharacters,
                      })
                    }
                  }
                  break
                case "zipCodeRule":
                  var zip = param.zip??param?.Zip
                  var country = param?.country
                  console.log("param",param);
                  
                  const zipCodeRuleUSA = /^\d{5}(?:[-\s]\d{4})?$/ //can be either 5 digits or 5-4 digits for US
                  if (country=="USA"&&!zipCodeRuleUSA.test(zip)){
                    validationErrorMessages.push({
                      field_name: 'zip',
                      message: `zipcode54`,
                    })
                  }
              }
            }
          }
        }
      }
      return validationErrorMessages
    }